import { AxiosError } from 'axios';

export async function suppress404<T>(p: Promise<T>): Promise<T | null> {
  try {
    return await p;
  } catch (e) {
    if (!(e instanceof AxiosError)) {
      throw e;
    }
    if (e.response?.status === 404) {
      return null;
    }
    throw e;
  }
}
